import styles from './Navigation.module.scss';

function NavbarItem({ icon: IconComponent, label, isActive, handleNavigation, isOpen }) {
  return (
    <div
      onClick={handleNavigation}
      style={{ width: isOpen ? "100%" : "fit-content" }}
      className={`${styles.navbarItem} ${isActive ? styles.activeNavbarItem : ''}`}>
      {IconComponent && (
        <IconComponent className={styles.navbarItemIcon} />
      )}
      {isOpen && <span className={styles.navbarItemLabel}>{label}</span>}
    </div>
  );
}

export default NavbarItem;
